import { createContext, lazy, Suspense, useState, useEffect } from 'react'

const DefaultState = {
  content: '',
  modalIsOpen: false,
}

export const LoginModalContext = createContext(DefaultState)

export const LoginModalConsumer = LoginModalContext.Consumer

const Modal = lazy(() => import('../components/LoginModal'))

export function LoginModalProvider({ children }) {
  const [isModalOpen, setModalOpen] = useState(DefaultState.modalIsOpen)

  return (
    <>
      <LoginModalContext.Provider
        value={{
          openLoginModal: () => setModalOpen(true),
        }}
      >
        <Suspense
          fallback={<i className="fas fa-2x fa-spinner-third fa-spin" />}
        >
          {isModalOpen && (
            <Modal
              modalIsOpen={isModalOpen}
              closeModal={() => setModalOpen(false)}
            />
          )}
          {children}
        </Suspense>
      </LoginModalContext.Provider>
    </>
  )
}
